import React from 'react'
import { List, Space, Button, Avatar, Tag } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, UserOutlined } from '@ant-design/icons'
import type { Bid } from '../types/rfq.types'
import { formatINR, formatIST } from '../../../shared/utils/formatters'

interface RFQBidsListProps {
    bids: Bid[]
    onAccept: (bid: Bid) => void
    onReject: (bid: Bid) => void
}

export const RFQBidsList: React.FC<RFQBidsListProps> = ({ bids, onAccept, onReject }) => {
    if (bids.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
                No bids received yet
            </div>
        )
    }

    return (
        <List
            itemLayout="horizontal"
            dataSource={bids}
            renderItem={(bid) => (
                <List.Item
                    actions={[
                        <Button
                            type="primary"
                            size="small"
                            icon={<CheckCircleOutlined />}
                            onClick={() => onAccept(bid)}
                        >
                            Accept
                        </Button>,
                        <Button
                            danger
                            size="small"
                            icon={<CloseCircleOutlined />}
                            onClick={() => onReject(bid)}
                        >
                            Reject
                        </Button>,
                    ]}
                >
                    <List.Item.Meta
                        avatar={<Avatar icon={<UserOutlined />} />}
                        title={bid.merchant_name || `Merchant #${bid.merchant_id}`}
                        description={
                            <Space direction="vertical" size="small">
                                <div>
                                    <strong>Amount:</strong> {formatINR(bid.price)}
                                </div>
                                <div>
                                    <strong>Delivery:</strong> {bid.delivery_days} days
                                </div>
                                <div>
                                    <strong>Submitted:</strong> {formatIST(bid.created_at)}
                                </div>
                                <Tag color={bid.status === 'accepted' ? 'green' : bid.status === 'rejected' ? 'red' : 'orange'}>
                                    {bid.status.toUpperCase()}
                                </Tag>
                            </Space>
                        }
                    />
                </List.Item>
            )}
        />
    )
}
